import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { getSubscriptionStatus } from "@/lib/api";

/** Wraps selling screens: shows a lock card when the plan isn't active. Children render only when active. */
export const SubscriptionGate = ({ children }) => {
  const [sub, setSub] = useState(null);
  useEffect(() => {
    let alive = true;
    getSubscriptionStatus().then((s) => alive && setSub(s)).catch(() => alive && setSub({ is_active: true }));
    return () => { alive = false; };
  }, []);
  if (!sub) return null;
  if (sub.is_active) return children;
  const planName = sub.plan_info?.name || (sub.plan === "onepay" ? "ONE PAY" : "CHALANITO");
  return (
    <div className="rounded-3xl border border-[#ff5a00]/40 bg-[#ff5a00]/[0.06] p-8 md:p-12 text-center" data-testid="subscription-gate">
      <div className="mx-auto w-14 h-14 rounded-2xl bg-[#ff5a00] text-black flex items-center justify-center mb-5"><Lock size={24} /></div>
      <h2 className="font-display text-3xl md:text-4xl tracking-tighter">{sub.is_expired ? "Tu periodo terminó" : sub.is_suspended ? "Tienda suspendida" : "Activa tu plan para cobrar"}</h2>
      <p className="text-white/60 mt-3 max-w-md mx-auto text-sm">
        Plan {planName} · ${sub.plan_price_usd} USD/{sub.plan === "onepay" ? "año" : "mes"}. Paga con tarjeta o SPEI y en cuanto se confirme podrás registrar ventas. Tu inventario sigue intacto.
      </p>
      <Link to="/pagar" className="btn-primary inline-flex mt-6" data-testid="subscription-gate-pay">Pagar ahora <ArrowRight size={16} /></Link>
    </div>
  );
};
